var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{staticStyle:{"z-index":"99999999","min-width":"80px"},attrs:{"id":"chatbotTelCo","data-token":_vm.token}})])}
var staticRenderFns = []

export { render, staticRenderFns }